import { styled } from "styled-components";

export const P = styled.p``;

export const Bold = styled.strong`
  font-weight: 700;
`;

export const Italic = styled.em``;

export const Underline = styled.u``;

export const OrderedList = styled.ol`
  list-style: none;
  margin: 0;
  padding-left: 2.5rem;

  /* Each <ol> starts its own counter scope */
  counter-reset: item;

  > li {
    counter-increment: item;
    position: relative;
    margin: 0.25em 0;
    padding-left: 0.75rem;
    line-height: 1.5;

    &::before {
      content: counters(item, ".") ". ";
      position: absolute;
      left: -1.75rem;
      opacity: 0.7;
      font-weight: 600;
      min-width: 1.5rem;
      text-align: right;
    }

    /* 🔁 Restart numbering for every nested <ol> */
    > ol {
      counter-reset: item; /* ⬅️ this is the key line */
      list-style: none;
      margin: 0.25em 0;
      padding-left: 2.5rem;
    }

    /* Nested <ul> inside <ol> */
    > ul {
      list-style: none;
      margin: 0.25em 0;
      padding-left: 2.5rem;

      /* Nested ordered list inside that unordered list */
      > ol {
        list-style: none;
        counter-reset: item; /* ✅ restarts from 1 */
        margin: 0.25em 0;
        padding-left: 2.5rem;
      }
    }
  }
`;

export const Variant = styled.span`
  color: ${({ theme }) => theme.colors.primary[500]};
  background: rgba(0, 85, 170, 0.08);
  border-radius: 3px;
  padding: 0 2px;
`;

export const VariantWordSpan = styled.span`
  position: relative;
  color: ${({ theme }) => theme.colors.primary.default};
  border-radius: 3px;
  padding: 0 2px;
`;

export const UnorderedList = styled.ul`
  list-style: none;
  margin: 0;
  padding-left: 2.5rem;

  > li {
    position: relative;
    margin: 0.25em 0;
    padding-left: 0.75rem;
    line-height: 1.5;

    /* Bullet */
    &::before {
      content: "";
      position: absolute;
      left: -1.5rem;
      top: 0.6em;
      width: 0.4em;
      height: 0.4em;
      border-radius: 50%;
      background-color: currentColor;
      opacity: 0.6;
    }

    /* Nested unordered list */
    > ul {
      list-style: none;
      margin: 0.25em 0;
      padding-left: 2.5rem;
    }

    /* ✅ Nested ordered list inside unordered */
    > ol {
      list-style: none;
      counter-reset: item; /* ✅ restart numbering at 1 */
      margin: 0.25em 0;
      padding-left: 2.5rem;

      > li {
        position: relative;
        counter-increment: item;
        padding-left: 0.75rem;

        &::before {
          content: counters(item, ".") ". ";
          position: absolute;
          left: -1.75rem;
          opacity: 0.7;
          font-weight: 600;
          min-width: 1.5rem;
          text-align: right;
        }

        /* deeper nested lists */
        > ol,
        > ul {
          margin: 0.25em 0;
          padding-left: 2.5rem;
          counter-reset: item;
        }
      }
    }
  }
`;

export const Heading = styled.h5`
  font-size: 1.5em;
  font-weight: 700;
`;

export const Link = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.primary[700]};
  }
`;
